import React, { useContext, useState } from 'react';
import styled from 'styled-components';
import moment from 'moment';

import ShopModeContext from '../contexts/ShopModeContext';
import AuthContext from '../contexts/AuthContext';
import {
  cancelMobiliansPayment,
  updatePayment,
  updateInicisPayment,
  cancelInicisPayment,
} from '../modules/NetworkFunction';

function PaymentTable(props) {
  const { payments, rowCount, setIsInicisPaid } = props;

  const { auth: token } = useContext(AuthContext);
  const { shopMode } = useContext(ShopModeContext);

  const [testUrl, setTestUrl] = useState('https://test.wizmon.com:3001');
  const [serverUrl, setServerUrl] = useState('https://shop.wizmon.co.kr');

  const handleRefund = (payment) => {
    if (shopMode === 'cafe24') {
      const { orderId, payToken, price, hmac, paymentNo, paymentDate } =
        payment;

      // 결제일 기준 7일 이내에만 환불 가능
      if (moment().isBefore(moment(paymentDate).add(7, 'days'))) {
        cancelMobiliansPayment(
          {
            orderId,
            payToken,
            price,
            hmac,
            paymentDate,
          },
          (data) => {
            if (data.code === '0000') {
              updatePayment(
                { paymentNo, refundYn: 1, refundDate: new Date() },
                () => {
                  alert('환불이 완료되었습니다.');
                  window.location.reload();
                },
                () => {},
                (error) => {
                  console.error(error);
                },
                token
              );
            }
          },
          (error) => {
            console.error(error);
          },
          token
        );
      }
    } else {
      console.log('이니시스 결제 취소 로직');
      cancelInicisPayment(
        {
          key: payment.INIAPIKey,
          mid: payment.mid,
          type: 'refund',
          clientIp: testUrl,
          tid: payment.tid,
        },
        (data) => {
          console.log('data: ', data);
          if (data.resultCode === '00') {
            updateInicisPayment(
              {
                paymentNo: payment.paymentNo,
                refundYn: 1,
                refundDate: new Date(),
              },
              () => {
                alert('환불이 완료되었습니다.');
                window.location.reload();
              },
              () => {},
              (error) => {
                console.error(error);
              },
              token
            );
            setIsInicisPaid(false);
          }
        },
        (error) => {
          console.error(error);
        },
        token
      );
    }
  };

  const tbodyContents =
    shopMode === 'cafe24' ? (
      !payments || payments.length === 0 ? (
        <tr style={{ height: 50 }}>
          {Array.from({ length: 5 }).map((_, index) => (
            <TableData key={index}>-</TableData>
          ))}
        </tr>
      ) : (
        // 결제 관리 페이지에선 2개 행까지만 보여줌
        payments.slice(0, rowCount).map((payment, index) => (
          <tr key={index} style={{ height: 50 }}>
            <TableData>
              {moment(payment.pay_date || payment.paymentDate).format(
                'YYYY.MM.DD HH:mm:ss'
              )}
            </TableData>
            <TableData>{payment.title}</TableData>
            <TableData>
              {new Intl.NumberFormat('ko-KR').format(
                payment.payment_amount || payment.price
              ) + '원'}
            </TableData>
            <TableData>
              {payment.refund_date === null || payment.refundDate === null
                ? 'O'
                : '환불됨'}
            </TableData>
            <TableData>
              {/** 메이크샵: 모빌리언스 환불, 카페24: 카페24에서 환불 신청 */}
              {shopMode === 'makeshop' ? (
                payment.refundDate === null ? (
                  <button
                    onClick={() => {
                      handleRefund(payment);
                    }}
                    style={{
                      alignItems: 'center',
                      cursor: 'pointer',
                      position: 'relative',
                      color: '#FF7A00',
                      fontSize: '16px',
                      fontWeight: 400,
                      textDecorationLine: 'underline',
                      textAlign: 'center',
                      height: '25px',
                      border: 'none',
                      backgroundColor: 'transparent',
                    }}
                  >
                    환불하기
                  </button>
                ) : (
                  'O'
                )
              ) : payment.refund_date === null ? (
                'X'
              ) : (
                'O'
              )}
            </TableData>
          </tr>
        ))
      )
    ) : // shopMode === 'makeshop'
    !payments || payments.length === 0 ? (
      <tr style={{ height: 50 }}>
        {Array.from({ length: 5 }).map((_, index) => (
          <TableData key={index}>-</TableData>
        ))}
      </tr>
    ) : (
      // 결제 관리 페이지에선 2개 행까지만 보여줌
      payments.slice(0, rowCount).map((payment, index) => (
        <tr key={index} style={{ height: 50 }}>
          <TableData>
            {moment(payment.pay_date || payment.paymentDate).format(
              'YYYY.MM.DD HH:mm:ss'
            )}
          </TableData>
          <TableData>{payment.title}</TableData>
          <TableData>
            {new Intl.NumberFormat('ko-KR').format(
              payment.payment_amount || payment.price
            ) + '원'}
          </TableData>
          <TableData>
            {payment.refund_date === null || payment.refundDate === null
              ? 'O'
              : '환불됨'}
          </TableData>
          <TableData>
            {/** 메이크샵: 모빌리언스 환불, 카페24: 카페24에서 환불 신청 */}
            {payment.refundDate === null ? (
              <button
                onClick={() => {
                  handleRefund(payment);
                }}
                style={{
                  alignItems: 'center',
                  cursor: 'pointer',
                  position: 'relative',
                  color: '#FF7A00',
                  fontSize: '16px',
                  fontWeight: 400,
                  textDecorationLine: 'underline',
                  textAlign: 'center',
                  height: '25px',
                  border: 'none',
                  backgroundColor: 'transparent',
                }}
              >
                환불하기
              </button>
            ) : (
              'O'
            )}
          </TableData>
        </tr>
      ))
    );

  return (
    <table>
      <thead>
        <tr
          style={{
            background: 'rgba(196, 196, 196, 0.21)',
            textAlign: 'center',
            border: '1px solid #CCC',
            height: 50,
            fontWeight: 400,
            fontSize: 18,
          }}
        >
          <TableData width="210">결제 일시</TableData>
          <TableData width="220">결제 서비스</TableData>
          <TableData width="120">결제 요금</TableData>
          <TableData width="100">결제 여부</TableData>
          <TableData width="100">환불 여부</TableData>
        </tr>
      </thead>
      <tbody>{tbodyContents}</tbody>
    </table>
  );
}

export default PaymentTable;

const TableData = styled.td`
  border: 1px solid #ccc;
  text-align: center;
`;
